<template>
  <!-- 保存确认弹窗 -->
  <BasePopup
    :visible="visible"
    popup-class="save-confirm-popup"
    :show-close-btn="true"
    :mask-closable="true"
    @close="handleClose"
    @update:visible="$emit('update:visible', $event)"
  >
    <!-- 自定义内容 -->
    <div class="save-confirm-content">
      <div class="save-confirm-title" v-if="title">{{ title }}</div>
      <div class="save-confirm-message">{{ message }}</div>
    </div>
    
    <!-- 按钮区域 -->
    <template #footer>
      <div class="save-confirm-buttons">
        <div class="confirm-button" @click="confirmSave"></div>
        <div class="cancel-button" @click="cancelSave"></div>
      </div>
    </template>
  </BasePopup>
</template>

<script setup>
import BasePopup from './BasePopup.vue';

// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  message: {
    type: String,
    default: "是否保留本次編輯的內容？",
  },
});

// 定义 emits
const emit = defineEmits(["update:visible", "confirm", "cancel"]);

// 关闭弹窗（点击X或遮罩）
const handleClose = () => {
  emit("update:visible", false);
};

// 确认保存
const confirmSave = () => {
  emit("confirm");
  emit("update:visible", false);
};

// 取消（不保存，直接关闭）
const cancelSave = () => {
  emit("cancel");
  emit("update:visible", false);
};
</script>

